import { render, staticRenderFns } from "./ListarEvidencia.vue?vue&type=template&id=f2387790&"
import script from "./ListarEvidencia.vue?vue&type=script&lang=js&"
export * from "./ListarEvidencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/apuracao/pendencias/ListarEvidencia.vue
// module id = 109
// module chunks = 28